"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var path_helper_1 = require("./config/path.helper");
var changet_data_response_serializer_1 = require("./util/changet-data-response.serializer");
var operators_1 = require("rxjs/operators");
var from_1 = require("rxjs/observable/from");
/**
 * @author gevorg.avetisyan on 2/10/2017.
 */
var HttpIPPTService = /** @class */ (function () {
    function HttpIPPTService(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.meServiceUriKey = "me-de-service-url";
        this.meServiceUri$ = from_1.from(this.applicationPropertiesService.getProperty(this.meServiceUriKey));
    }
    HttpIPPTService.prototype.validateTrackingData = function (indicatorId, body) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.post(url + path_helper_1.PathHelper.INDICATOR + indicatorId + "/tracking-data/validate", body); }));
    };
    HttpIPPTService.prototype.checkExistingTrackingData = function (checkBody) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.post(url + path_helper_1.PathHelper.INDICATOR + "tracking-data/check", checkBody); }), operators_1.map(function (res) { return changet_data_response_serializer_1.ChangedDataResponseSerializer.Serializer(res); }));
    };
    /**
     * Method send request to ME Service to save modifications
     * @returns {Observable<any>}
     */
    HttpIPPTService.prototype.getChangedDataRequest = function (request) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            var uri = "" + url + path_helper_1.PathHelper.IPPT;
            return _this.http.post(uri, request);
        }));
    };
    /**
     * Method send request to ME Service to save modifications
     * @returns {Observable<any>}
     */
    HttpIPPTService.prototype.saveTrackingModificationsWithWorkflowIDM = function (request, indicatorId, valueTypeId, periodicityId, rfId, rfItemId, rfLevel, ifSystemName, ifItemId, actionId) {
        var _this = this;
        if ((!rfId || !rfItemId || !rfLevel) && (!ifSystemName || !ifItemId) || !valueTypeId || !periodicityId || !actionId) {
            throw new Error("Invalid parameters");
        }
        return this.meServiceUri$.flatMap(function (url) {
            var uri = "" + url + path_helper_1.PathHelper.INDICATOR + indicatorId + "/" + valueTypeId + "/" + periodicityId + "/tracking-data";
            if (rfId) {
                uri += "/" + rfId + "/" + rfItemId + "/" + rfLevel;
            }
            if (ifSystemName) {
                uri += "/" + ifSystemName + "/" + ifItemId;
            }
            return _this.http.put(uri + '/' + actionId, request).pipe(operators_1.map(function (res) { return changet_data_response_serializer_1.ChangedDataResponseSerializer.Serializer(res); }));
        });
    };
    /**
     * Method loaded tracking data from ME Service
     * @returns {Observable<R>}
     */
    HttpIPPTService.prototype.getIndicatorTrackingDataRequest = function (indicatorId, masterId, filter) {
        var _this = this;
        if (!masterId || !indicatorId) {
            throw new Error("Invalid input parameters");
        }
        var params = {};
        if (filter) {
            params = __assign({}, filter);
        }
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            var uri = "" + url + path_helper_1.PathHelper.IPPT + masterId + path_helper_1.PathHelper.INDICATORS + "/" + indicatorId;
            return _this.http.get(uri, { params: params });
        }));
    };
    HttpIPPTService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpIPPTService);
    return HttpIPPTService;
}());
exports.HttpIPPTService = HttpIPPTService;
//# sourceMappingURL=http-ippt.service.js.map